import React from 'react';
import Webshop from "./Webshop";
import ProductGrid from '../ProductGrid';

function App() {
  return (
    <div className="App">
      <ProductGrid />
    </div>
  );
}
export default App;